import React from 'react';

import { Link } from 'react-router-dom';

import { useIntl } from 'react-intl';

import { DocumentationsType, LicencesType } from '@marketplace/api';

import '../style.scss';

export type TDocumentationProps = {
  documentations: DocumentationsType[];
  licenses: LicencesType[];
};

export const Documentation = ({
  documentations,
  licenses,
}: TDocumentationProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <div className={'app-gallery__app-details__documentation-tab'}>
      <div className="app-gallery__app-details__documentation-tab__container">
        <div className="app-gallery__app-details__documentation-tab__header">
          <div className="app-gallery__app-details__documentation-tab__header-title">
            {formatMessage({
              id: 'app_gallery_tab_doc_details_content_title',
            })}
          </div>
        </div>
        <div className="app-gallery__app-details__documentation-tab__content">
          {documentations &&
            documentations.map(
              ({ id, name, url, support_description }: DocumentationsType) => (
                <div key={id}>
                  <div className="app-gallery__app-details__documentation-tab__content-title">
                    {!url && <span>{name}</span>}
                    {url && 
                      <Link
                        to={{ pathname: url }}
                        className="url"
                        target="_blank"
                        key={id}
                      >
                        {name}
                      </Link>
                    }
                  </div>
                  <div className="app-gallery__app-details__documentation-tab__content-value">
                    <span className='support-description'>{support_description}</span>
                  </div>
                </div>
              )
            )}
        </div>

        <div className="app-gallery__app-details__documentation-tab__content">
          <div className="app-gallery__app-details__documentation-tab__content-title">
            {formatMessage({
              id: 'app_gallery_tab_doc_details_content_subtitle_license',
            })}
          </div>
          <div className="app-gallery__app-details__documentation-tab__content-value">
            {licenses &&
              licenses.map(({ url, id }: LicencesType) => (
                <Link
                  to={{ pathname: url }}
                  className="url"
                  target="_blank"
                  key={id}
                >
                  {url}
                </Link>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
